import { IntlProvider } from 'react-intl';
import { legacy_connect as connect } from 'react-redux';

import { AppState } from '../../store/reducers/root';
import {
  getCurrentLocaleMessages,
  getCurrentLocaleName,
} from '../../store/selectors/intl';

const mapStateToProps = (state: AppState) => {
  const locale = getCurrentLocaleName(state);
  const messages = getCurrentLocaleMessages(state);
  return { key: locale, locale, messages, defaultLocale: 'en' };
};

export default connect(mapStateToProps)(IntlProvider);
